<template>
    <div class="gestion-section">
        <div class="gestion-content">
            <h2 class="gestion-title fuente-posm">
                Gestión de Menús en Un Solo Sistema
            </h2>
            <p class="gestion-text fuente-nova">
                Actualiza tu menú una sola vez y se sincroniza automáticamente en tu sitio, app, Rappi y Uber Eats. Modifica precios, agrega platillos o marca productos como agotados desde un solo panel.
                <br><br>
                Los pedidos de todas las plataformas llegan automáticamente a tu sistema. Se acabó capturar manualmente y cometer errores.
            </p>
        </div>
        <div class="gestion-image">
            <img :src="a70" alt="Gestión de menús">
        </div>
    </div>
</template>

<script>
export default {
    name: 'GestionMenusNew',
    data() {
        return {
            a70: require('@/assets/images/a70.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.gestion-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.gestion-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.gestion-image img {
    width: 400px;
    height: auto;
}

.gestion-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.gestion-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.gestion-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .gestion-title {
        font-size: 60px;
    }

    .gestion-text {
        font-size: 27px;
    }

    .gestion-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .gestion-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .gestion-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .gestion-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .gestion-image img {
        width: 80%;
        max-width: 320px;
    }

    .gestion-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .gestion-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
